module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('accordion', {
    attrs: {
      "collections": _vm.groupTerms,
      "initialExpanded": _vm.expandedGroupTerm
    },
    on: {
      "expanded": _vm.showGroupTerm
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(groupTerm) {
        return [_c('timeline', {
          attrs: {
            "items": _vm.timelineItems,
            "isActive": _vm.isPeriodActive,
            "isMarked": _vm.isPeriodCurrent
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function(data) {
              return [_c('period', {
                attrs: {
                  "groupPeriod": data.groupPeriod,
                  "start": data.start,
                  "end": data.end,
                  "isDemo": _vm.isDemo
                }
              })]
            }
          }])
        })]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-710adb94","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/sidebar/SidebarContentTerms.vue
// module id = 4U3r
// module chunks = 1